import React from 'react';
import { motion } from 'framer-motion';
import { Box, Flex, Text } from '@chakra-ui/react';

const SocialProof = () => {
  const logos = [
    { name: 'Jira', url: 'https://cdn.simpleicons.org/jira/0052CC', status: 'live' },
    { name: 'ClickUp', url: 'https://cdn.simpleicons.org/clickup/7B68EE', status: 'live' },
    { name: 'Notion', url: 'https://cdn.simpleicons.org/notion/000000', status: 'planned' },
    { name: 'Slack', url: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/slack.svg', status: 'planned' },
    { name: 'Asana', url: 'https://cdn.simpleicons.org/asana/F06A6A', status: 'planned' },
    { name: 'Linear', url: 'https://cdn.simpleicons.org/linear/5E6AD2', status: 'planned' },
  ];

  return (
    <Box
      as="section"
      id="social-proof"
      bg="landing.surface"
      py={{ base: 10, md: 12 }}
      borderTopWidth="1px"
      borderBottomWidth="1px"
      borderColor="landing.border"
      fontFamily="body"
    >
      <Box maxW="1100px" mx="auto" px={{ base: 5, md: 8 }}>
        <Flex
          direction={{ base: 'column', md: 'row' }}
          align="center"
          justify="center"
          gap={{ base: 8, md: 16 }}
        >
          <Box textAlign={{ base: 'center', md: 'left' }}>
            <Text fontSize="xs" fontWeight="800" color="text.muted" letterSpacing="0.1em" textTransform="uppercase" whiteSpace="nowrap">
              Available now for
            </Text>
            <Text fontSize="10px" color="brand.primary" fontWeight="700" mt={1}>
              Jira and ClickUp are live today. More connectors are planned.
            </Text>
          </Box>
          <Flex wrap="wrap" justify="center" align="center" gap={{ base: 8, md: 12 }}>
            {logos.map((logo, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: logo.status === 'live' ? 0.6 : 0.3 }}
                whileHover={{ opacity: 1, scale: 1.05 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1, duration: 0.5 }}
                style={{ position: 'relative' }}
              >
                <img
                  src={logo.url}
                  alt={logo.name}
                  style={{ height: '24px', filter: 'grayscale(100%)', opacity: logo.status === 'live' ? 1 : 0.5 }}
                />
                {logo.status === 'planned' && (
                  <Text position="absolute" top="-12px" right="-20px" fontSize="7px" fontWeight="900" color="brand.primary" bg="brand.subtle" px={1} borderRadius="sm" whiteSpace="nowrap">
                    PLANNED
                  </Text>
                )}
              </motion.div>
            ))}
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default SocialProof;
